import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, PlayCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import './PromotionalModal.css';

export default function PromotionalModal() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const isDashboard = location.pathname.startsWith('/dashboard');
  const isReviewGate = location.pathname.startsWith('/r/');

  useEffect(() => {
    if (isAuthenticated || isDashboard || isReviewGate) return;

    const hasSeenModal = localStorage.getItem('reviio_promo_modal_seen');
    if (!hasSeenModal) {
      const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        const maxScroll = documentHeight - windowHeight;
        if (maxScroll <= 0) return;
        
        const scrollPercentage = (scrollPosition / maxScroll) * 100;
        
        if (scrollPercentage >= 40) {
          setIsVisible(true);
          window.removeEventListener('scroll', handleScroll);
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isAuthenticated, isDashboard, isReviewGate]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('reviio_promo_modal_seen', 'true');
  };

  const handleLogin = async () => {
    setLoading(true);
    try {
      await login('demo@reviio.app', 'Test1234!');
      localStorage.setItem('reviio_promo_modal_seen', 'true');
      setIsVisible(false);
      navigate('/dashboard');
    } catch (err) {
      console.error('Demo login failed', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="promo-modal-overlay">
      <div className="promo-modal-content">
        <button className="promo-modal-close" onClick={handleClose} aria-label={t('common.close')}>
          <X size={20} />
        </button>
        
        <div className="promo-modal-body">
          <div className="promo-modal-icon">
            <PlayCircle size={48} className="text-primary" />
          </div>
          <h2 className="promo-modal-title">{t('promoModal.exploreTheDashboard')}</h2>
          <p className="promo-modal-text">{' ' + t('promoModal.seeHowTheDashboardLooksAnd')}
          </p>
          
          <button 
            className="btn btn-primary promo-modal-btn" 
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? <span className="spinner spinner-sm" /> : t('promoModal.tryDemoDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
}
